var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Axios from 'axios';
import { HOST } from 'config';
import { dAxios, snackBarRsp } from 'consts';
import { setBrokerBansAdvRedux } from 'reducers/Projcet/ADV/action';
import { setBrokerBansInqRedux } from 'reducers/Projcet/INQ/action';
import { setBrokerBansPayRedux } from 'reducers/Projcet/PAY/action';
import { setBrokerBansRelRedux } from 'reducers/Projcet/REL/action';
import { setRealnameCancelRedux, setCustomsVerifyRedux, setNotificationFunctioncodeRedux, } from 'reducers/systemCode/action';
import { CUSTOMS_VERIFY, NOTIFICATION_FUNCTIONCODE, REALNAME_CANCEL, } from 'reducers/systemCode/types';
import { option2Trans } from 'component/consts';
// API Func ----------------------------------------------------------------
export var getToken = function (enqueueSnackbar) { return __awaiter(void 0, void 0, Promise, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dAxios('POST', HOST + "auth/token", {
                    authId: '',
                    lang: 'TW',
                }, enqueueSnackbar)];
            case 1:
                response = _a.sent();
                if (!snackBarRsp(enqueueSnackbar, response)) {
                    return [2 /*return*/];
                }
                if (response) {
                    window.sessionStorage.setItem('jwt', "Bearer " + response.data.data.token);
                    Axios.defaults.headers.Authorization = "Bearer " + response.data.data.token;
                }
                return [2 /*return*/];
        }
    });
}); };
// 最新消息
export var getAnnouncement = function (enqueueSnackbar) { return __awaiter(void 0, void 0, Promise, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dAxios('GET', HOST + "v1/system/announcement", {
                    source: 'W',
                    type: 'A',
                    lang: 'TW',
                }, enqueueSnackbar)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, (response === null || response === void 0 ? void 0 : response.data.data) || []];
        }
    });
}); };
// 報關業者
export var getBrokerBan = function (dispatch, enqueueSnackbar, brokerType) { return __awaiter(void 0, void 0, Promise, function () {
    var response, options;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dAxios('get', HOST + "v1/broker/attorney", {
                    brokerType: brokerType,
                    lang: 'TW',
                }, enqueueSnackbar, { timeout: 180000 })];
            case 1:
                response = _a.sent();
                if (response && response.data) {
                    options = ((response === null || response === void 0 ? void 0 : response.data.data) || []).map(function (obj) {
                        return ({
                            value: obj.brokerBan,
                            label: obj.companyNameC,
                        });
                    });
                    switch (brokerType) {
                        case 'P': // PAY
                            dispatch(setBrokerBansPayRedux(option2Trans(options)));
                            break;
                        case 'R': // REL
                            dispatch(setBrokerBansRelRedux(option2Trans(options)));
                            break;
                        case 'A': // INQ
                            dispatch(setBrokerBansInqRedux(option2Trans(options)));
                            break;
                        case 'C': // ADV
                            dispatch(setBrokerBansAdvRedux(option2Trans(options)));
                            break;
                        default:
                            break;
                    }
                }
                return [2 /*return*/];
        }
    });
}); };
// 系統代碼
export var getSystemCode = function (dispatch, enqueueSnackbar, typeId, codeId) { return __awaiter(void 0, void 0, Promise, function () {
    var response, options;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dAxios('get', HOST + "v1/system/system-code", {
                    typeId: typeId,
                    codeId: codeId,
                    status: 'Y',
                    lang: 'TW',
                }, enqueueSnackbar)];
            case 1:
                response = _a.sent();
                if (response && response.data) {
                    options = ((response === null || response === void 0 ? void 0 : response.data.data) || []).map(function (obj) {
                        return ({
                            value: obj.data01,
                            label: obj.data02,
                        });
                    });
                    switch (typeId + "_" + codeId) {
                        case CUSTOMS_VERIFY: // REL00002_edit
                            dispatch(setCustomsVerifyRedux(option2Trans(options.filter(function (obj) { return obj.value !== '00'; }))));
                            break;
                        case REALNAME_CANCEL: // REL00007_edit
                            dispatch(setRealnameCancelRedux(option2Trans(options.filter(function (obj) { return obj.value.indexOf('A') === 0; }))));
                            break;
                        case NOTIFICATION_FUNCTIONCODE: // REL00006_home
                            dispatch(setNotificationFunctioncodeRedux(option2Trans(options)));
                            break;
                        default:
                            break;
                    }
                }
                return [2 /*return*/];
        }
    });
}); };
